var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-image-photo-journey-skeleton"},[_c('AnimatedPlaceholder',{attrs:{"height":"180px","width":"100%","border-radius":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }